import { Controller } from "@hotwired/stimulus"

// The planner's track field: a full-width trigger, and the shared track picker
// in a frame that is fetched the first time it is asked for.
//
// The lazy frame is the whole reason this is a controller rather than a plain
// button. The picker's list draws an outline SVG per track, so a season page
// with ten rounds would carry ten full lists; the frame stays unfetched until a
// round's track field is opened, and opens itself when it lands (`autoopen`).
// Every open after that has to ask the picker, because by then it exists and
// nothing is loading.
export default class extends Controller {
  static targets = ["trigger", "editor"]

  open() {
    // Revealing the frame is what triggers the fetch; the picker then opens
    // against the trigger named in its `anchor` value.
    this.editorTarget.classList.remove("hidden")

    this.editorTarget
      .querySelector("[data-controller~='track-picker']")
      ?.dispatchEvent(
        new CustomEvent("track-picker:openRequest", {
          detail: { anchor: this.triggerTarget },
        }),
      )
  }
}
